import { render, staticRenderFns } from "./feeDetailReceipt.vue?vue&type=template&id=4d11f64a"
import script from "./feeDetailReceipt.vue?vue&type=script&lang=js"
export * from "./feeDetailReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports